// extracted by mini-css-extract-plugin
export default {"cancelBtn":"CancelBtn_cancelBtn__1H5ic"};